import React, { useState, useEffect } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

function copyText(t) { navigator.clipboard.writeText(t||'').then(()=>toast.success('Copied!')).catch(()=>{}); }

export default function NoContact() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({});

  useEffect(()=>{
    load();
    api.get('/settings/public').then(r=>setSettings(r.data||{})).catch(()=>{});
  },[]);

  async function load() {
    setLoading(true);
    try { const r=await api.get('/reports/no-contact'); setItems(r.data||[]); }
    catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }

  const autoCancelDays = parseInt(settings.auto_cancel_days||5);
  const followupDays = parseInt(settings.followup_days||3);

  const buildFollowupMsg = (item) => {
    const phones = item.customer_phones?.length ? item.customer_phones : item.customer_phone ? [item.customer_phone] : [];
    return `សួស្តី ${item.customer_name} 👋\n\nក្រុមហ៊ុន 123 Crystal ចង់ជូនដំណឹងថា អ្នកមានការបញ្ជាទិញចំនួន $${item.total.toFixed(2)} ដែលរង់ចាំការបញ្ជាក់ទីតាំង។\n\nសូមផ្ញើ:\n📍 អាសយដ្ឋាន\n📞 លេខទូរស័ព្ទ\n🚚 វិធីដឹកជញ្ជូន\n\nសូមអរគុណ 🙏\n123 Crystal`;
  };

  return (
    <div style={{ padding:24, minHeight:'100vh', background:'#f8fafc' }}>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:700, color:'#111827' }}>📵 No Contact Queue</h1>
        <p style={{ margin:'2px 0 0', fontSize:13, color:'#6b7280' }}>
          Customers with pending bills but no delivery method — need follow-up · Auto-cancel after {autoCancelDays} days
        </p>
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
        {[
          ['Total', items.length, '#374151'],
          ['Urgent ('+followupDays+'+ days)', items.filter(i=>i.days_pending>=followupDays).length, '#f59e0b'],
          ['Critical ('+autoCancelDays+'+ days)', items.filter(i=>i.days_pending>=autoCancelDays).length, '#dc2626'],
        ].map(([label,val,color])=>(
          <div key={label} style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:8, padding:'14px 18px', textAlign:'center' }}>
            <div style={{ fontSize:24, fontWeight:700, color }}>{val}</div>
            <div style={{ fontSize:12, color:'#6b7280' }}>{label}</div>
          </div>
        ))}
      </div>

      {loading&&<div style={{ textAlign:'center', padding:40, color:'#9ca3af' }}>Loading...</div>}

      {!loading&&items.length===0&&(
        <div style={{ textAlign:'center', padding:40, color:'#9ca3af' }}>🎉 No customers in no-contact queue</div>
      )}

      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {items.map(item=>{
          const urgent = item.days_pending >= followupDays;
          const critical = item.days_pending >= autoCancelDays;
          const phones = item.customer_phones?.length ? item.customer_phones : item.customer_phone ? [item.customer_phone] : [];
          return (
            <div key={item.bill_id} style={{ background:'#fff', border:`1px solid ${critical?'#fca5a5':urgent?'#fcd34d':'#e5e7eb'}`, borderRadius:10, padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:4 }}>
                    <span style={{ fontWeight:700, fontSize:14, color:'#111827' }}>{item.customer_name}</span>
                    <span style={{ fontFamily:'monospace', fontSize:11, color:'#7c6af5', background:'#ede9fe', padding:'1px 8px', borderRadius:6 }}>{item.bill_number}</span>
                    {critical&&<span style={{ fontSize:11, background:'#fee2e2', color:'#dc2626', padding:'1px 8px', borderRadius:8, fontWeight:600 }}>⚠️ {item.days_pending}d — Critical</span>}
                    {!critical&&urgent&&<span style={{ fontSize:11, background:'#fef3c7', color:'#f59e0b', padding:'1px 8px', borderRadius:8, fontWeight:600 }}>⏰ {item.days_pending}d — Follow up</span>}
                    {!urgent&&<span style={{ fontSize:11, background:'#f3f4f6', color:'#6b7280', padding:'1px 8px', borderRadius:8 }}>{item.days_pending}d</span>}
                  </div>
                  <div style={{ display:'flex', gap:12, fontSize:12, color:'#6b7280', flexWrap:'wrap' }}>
                    {phones.map((p,i)=><span key={i}>📞 {p}</span>)}
                    {item.address&&<span>📍 {item.address}</span>}
                    <span>Created: {item.created_at}</span>
                    <span style={{ fontWeight:700, color:'#16a34a' }}>${item.total.toFixed(2)}</span>
                  </div>
                </div>
                <div style={{ display:'flex', gap:8, flexShrink:0 }}>
                  <button onClick={()=>{ navigator.clipboard.writeText(buildFollowupMsg(item)).then(()=>toast.success('Follow-up message copied!')).catch(()=>{}); }}
                    style={{ background:'#eff6ff', color:'#2563eb', border:'none', borderRadius:6, padding:'6px 12px', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                    📋 Copy DM
                  </button>
                  <button onClick={()=>{ if(window.confirm(`Cancel bill ${item.bill_number}?`)) api.put(`/billing/bills/${item.bill_id}/status`,{status:'cancelled',cancel_reason:'No contact — auto cancel'}).then(()=>{ toast.success('Cancelled'); load(); }).catch(()=>toast.error('Failed')); }}
                    style={{ background:'#fee2e2', color:'#dc2626', border:'none', borderRadius:6, padding:'6px 12px', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                    ❌ Cancel
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
